import { JOB_EVENTS } from '../../constants/events';


export const updateJob = (job = {}) => ({
  type: JOB_EVENTS.UPDATE_JOB,
  payload: job
});

export const updateNewJob = (job = {}) => ({
  type: JOB_EVENTS.UPDATE_NEW_JOB,
  payload: job
});

export const updateRsaData = function( data = {} ) {
  return {
    type: JOB_EVENTS.UPDATE_RSA_DATA,
    payload: data
  }
}


// WEBPACK FOOTER //
// ../q-jobs/src/actions/JobActions/index.js